import { useContractKit } from '@celo-tools/use-contractkit'
import StkCornV1 from '@masa-finance/smart-contracts/build/contracts/StkCornv1.json'
import TestMasa from '@masa-finance/smart-contracts/build/contracts/TestMasa.json'
import { ethers } from 'ethers'
import { useCallback, useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router'

import { Button, Card, CryptoIcon, Input, Spinner } from '../../components'
import { EtherscanAddress } from '../../components/etherscan-address'
import { Modal } from '../../components/modal'
import { PlatformStats } from '../../components/platform-stats'
import { PoolsTable } from '../../components/pools-table'
import { SimpleModal } from '../../components/simple-modal'
import { Paths } from '../../config/routes'

export function StakeDashboard() {
    const { kit } = useContractKit()

    const history = useHistory()
    const [openDeposit, setOpenDeposit] = useState(false)
    const [openWithdraw, setOpenWithdraw] = useState(false)
    const [depositing, setDepositing] = useState(false)
    const [validator, setBecameValidator] = useState(false)
    const [transactionAddress, setTransactionAddress] = useState<string | null>(
        null,
    )

    const [rewards, setRewards] = useState<null | string>(null)

    const [depositValue, setDeposit] = useState('')
    const [withdrawValue, setWithdraw] = useState('')
    const [error, setError] = useState<null | string>(null)
    const dataClasses = 'not-italic font-light text-sm leading-3 py-4'
    const enfasisClasses = ' text-black '

    const stake = async () => {
        let cornInstance = new kit.web3.eth.Contract(
            TestMasa.abi as any,
            TestMasa.networks['44787'].address,
            { gas: 20000000 },
        )

        let stkCornInstance = new kit.web3.eth.Contract(
            StkCornV1.abi as any,
            StkCornV1.networks['44787'].address,
            { gas: 20000000 },
        )

        const stkAmnt = ethers.utils.parseUnits(depositValue, 18)
        try {
            const approveTxRaw = await cornInstance.methods.approve(
                StkCornV1.networks['44787'].address,
                stkAmnt,
            )
            let approveTx = await kit.sendTransactionObject(approveTxRaw, {
                gas: 20000000,
                gasPrice: ethers.utils.parseUnits('10', 9).toString(),
            })
            const approveReceipt = await approveTx.waitReceipt()

            if (approveReceipt.status !== true) {
                console.log('approval failed')
                return {
                    success: false,
                    error: 'Approval failed',
                }
            }
        } catch (e) {
            console.log(e)
            return {
                success: false,
                error: 'Approval failed',
            }
        }

        const stkTxRaw = stkCornInstance.methods.stake(stkAmnt)

        try {
            let stkTx = await kit.sendTransactionObject(stkTxRaw, {
                gas: 20000000,
                gasPrice: ethers.utils.parseUnits('10', 9).toString(),
            })

            const stkReceipt = await stkTx.waitReceipt()

            if (stkReceipt.status !== true) {
                return { success: false }
            }
            console.log({ stkReceipt })

            setTransactionAddress(stkReceipt.transactionHash)
        } catch (e: any) {
            console.log('ERROR', e.message)
            return {
                success: false,
                error: "You don't have enough CORN balance",
            }
        }

        return { success: true }
    }

    const unstake = async () => {
        let stkCornInstance = new kit.web3.eth.Contract(
            StkCornV1.abi as any,
            StkCornV1.networks['44787'].address,
            { gas: 20000000 },
        )

        const stkTxRaw = stkCornInstance.methods.unstake()

        try {
            let stkTx = await kit.sendTransactionObject(stkTxRaw, {
                gas: 20000000,
                gasPrice: ethers.utils.parseUnits('10', 9).toString(),
            })

            const stkReceipt = await stkTx.waitReceipt()

            if (stkReceipt.status !== true) {
                return { success: false }
            }

            setTransactionAddress(stkReceipt.transactionHash)
        } catch (e: any) {
            console.log('ERROR', e.message)
            return {
                success: false,
                error: "You don't have enough CORN balance",
            }
        }

        return { success: true }
    }

    const withdrawCorn = async () => {
        let stkCornInstance = new kit.web3.eth.Contract(
            StkCornV1.abi as any,
            StkCornV1.networks['44787'].address,
            { gas: 20000000 },
        )

        const wdTxRaw = stkCornInstance.methods.withdraw()

        try {
            let stkTx = await kit.sendTransactionObject(wdTxRaw, {
                gas: 20000000,
                gasPrice: ethers.utils.parseUnits('10', 9).toString(),
            })

            const stkReceipt = await stkTx.waitReceipt()

            if (stkReceipt.status !== true) {
                return { success: false }
            }

            setTransactionAddress(stkReceipt.transactionHash)
        } catch (e: any) {
            console.log('ERROR', e.message)
            return {
                success: false,
                error: "You don't have enough CORN balance",
            }
        }

        return { success: true }
    }

    const checkrewards = useCallback(async () => {
        let stkCornInstance = new kit.web3.eth.Contract(
            StkCornV1.abi as any,
            StkCornV1.networks['44787'].address,
            { gas: 20000000 },
        )

        const wdTxRaw = await stkCornInstance.methods.getStakingBalance().call()

        const val = +wdTxRaw / 1000000000000000000

        setRewards(val.toString())
        return val
    }, [kit.web3.eth.Contract])

    useEffect(() => {
        checkrewards()
    }, [checkrewards])

    const shrinkAnAddress = (address: string) => {
        const lastDigits = address.substring(address.length - 5)
        return address.substring(0, 2) + '...' + lastDigits
    }

    const deposit = async (e: any) => {
        setDepositing(true)
        setError(null)
        setTransactionAddress(null)
        e.preventDefault()

        const stakeResult = await stake()

        if (stakeResult.error) {
            setError(stakeResult.error)
            setBecameValidator(false)
        } else {
            setBecameValidator(true)
            setDeposit('')
        }
        console.log(withdrawCorn)
    }

    const withdraw = async (e: any) => {
        setDepositing(true)
        setError(null)
        setTransactionAddress(null)
        e.preventDefault()

        const stakeResult = await unstake()

        if (stakeResult.error) {
            setError(stakeResult.error)
            setBecameValidator(false)
        } else {
            setBecameValidator(true)
            setDeposit('')
        }
    }
    return (
        <>
            <div
                className='grid h-full gap-4 py-4 gird-cols-6'
                style={{ gridTemplateRows: '1fr 1fr' }}>
                <div className='col-span-4 row-span-1 xl:col-span-3'>
                    <Card className='w-full h-full py-8 '>
                        <h3>Stake to Become a 🌽 Masa Validator</h3>
                        <PoolsTable
                            headers={[
                                'Asset',
                                'Masa Staking contract',
                                'Staked tokens',
                                'Validators',
                                'Interest APY',
                            ]}
                            items={
                                <>
                                    <tr
                                        className='border-b border-solid border-gray border-opacity-10 group'
                                        data-test-id={`transaction-item`}>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-row justify-center w-full p-1'>
                                                <CryptoIcon name='USDC' />
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-row justify-center font-semibold truncate text-linkYellow'>
                                                <EtherscanAddress
                                                    address={'0x7899...67h7'}
                                                />
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-col items-center overflow-visible text-left break-words truncate'>
                                                <p className='font-normal text-black'>
                                                    15,000,256
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-col items-center overflow-visible text-left break-words truncate'>
                                                <p>
                                                    <span className='font-normal text-black'>
                                                        10
                                                    </span>{' '}
                                                    active
                                                </p>
                                                <p>
                                                    <span className='font-normal text-black'>
                                                        4
                                                    </span>{' '}
                                                    inactive
                                                </p>
                                            </div>
                                        </td>
                                        <td
                                            className={`${dataClasses} ${enfasisClasses}`}>
                                            <div className='flex flex-col items-center overflow-visible text-left break-words truncate'>
                                                <p>17% APY</p>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }
                        />

                        <div className='mt-4 border-b border-gray2'>
                            <h3>Your staked balances</h3>
                            <div className='flex flex-row w-full mb-4 border-b border-gray2'>
                                <p className='w-1/2 text-black'>
                                    CORN Balance: 0.00
                                </p>
                                <p className='w-1/2 text-black'></p>
                            </div>

                            <div className='grid grid-cols-2 grid-rows-1 gap-8'>
                                <div className='flex flex-col items-center'>
                                    <div className='flex flex-row justify-between w-full mb-4 text-sm font-light '>
                                        <p className='text-gray8'>
                                            Deposit CORN
                                        </p>
                                        <p className='text-gray8'>
                                            Wallet balance: 0 CORN
                                        </p>
                                    </div>
                                    <div className='relative flex flex-row items-center w-full'>
                                        <Input
                                            placeholder='Enter amount'
                                            type='number'
                                            value={depositValue}
                                            customStyle='number-input'
                                            onChange={e => {
                                                setDeposit(e.target.value)
                                            }}
                                        />
                                        <div className='absolute flex flex-row gap-x-4 right-6'>
                                            <p className='mb-0 '>CORN</p>
                                            <p className='mb-0 text-black'>
                                                Max
                                            </p>
                                        </div>
                                    </div>
                                    <Button
                                        disabled={!depositValue}
                                        className='w-full py-4 mt-4'
                                        onClick={() => {
                                            setError(null)
                                            setOpenDeposit(true)
                                        }}>
                                        Stake
                                    </Button>
                                </div>
                                <div className='flex flex-col items-center'>
                                    <div className='flex flex-row justify-between w-full mb-4 text-sm font-light '>
                                        <p className='text-gray8'>
                                            Withdraw CORN
                                        </p>
                                        <p className='text-gray8'>
                                            Staked balance: {rewards} CORN
                                        </p>
                                    </div>
                                    <div className='relative flex flex-row items-center w-full'>
                                        <Input
                                            placeholder='Enter amount'
                                            type='number'
                                            value={withdrawValue}
                                            customStyle='number-input'
                                            onChange={e => {
                                                setWithdraw(e.target.value)
                                            }}
                                        />
                                        <div className='absolute flex flex-row gap-x-4 right-6'>
                                            <p className='mb-0 '>CORN</p>
                                            <p className='mb-0 text-black'>
                                                Max
                                            </p>
                                        </div>
                                    </div>
                                    <Button
                                        className='w-full py-4 mt-4'
                                        onClick={() => setOpenWithdraw(true)}
                                        disabled={!withdrawValue}>
                                        Unstake
                                    </Button>
                                    {/* <Button
                                        className='w-full py-4 mt-4'
                                        onClick={() => checkrewards()}>
                                        Check Rewards
                                    </Button>
                                    <Button
                                        className='w-full py-4 mt-4'
                                        onClick={() => withdrawCorn()}>
                                        Withdraw!
                                    </Button> */}
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>

                <div className='col-span-4 row-span-1 xl:row-span-2 xl:col-start-4 xl:row-start-1 xl:col-span-1 '>
                    <Card>
                        <PlatformStats />
                    </Card>
                </div>
            </div>
            <Modal show={openDeposit} onClose={() => setOpenDeposit(false)}>
                <SimpleModal
                    onClose={() => {
                        setOpenDeposit(false)
                    }}
                    title={
                        error ? (
                            'There was an error with your transaction'
                        ) : validator ? (
                            'Deposit completed'
                        ) : depositing ? (
                            <div className='flex flex-row items-center gap-4'>
                                Waiting for confirmation
                                <Spinner color='black' />
                            </div>
                        ) : (
                            'Stake'
                        )
                    }
                    hideFooter={depositing && !validator}
                    buttons={[
                        {
                            label: validator ? 'Dashboard' : 'Stake',
                            onClick: validator
                                ? () => history.push(Paths.DASHBOARD_VALIDATOR)
                                : deposit,
                        },
                    ]}>
                    {!error ? (
                        <p className='font-light text-gray8'>
                            {!depositing ? (
                                <>
                                    Your are about to stake{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    CORN and become a Masa Validator.
                                </>
                            ) : validator ? (
                                <>
                                    You have staked{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    CORN tokens, you can now validate
                                    transactions and approve loans. Your
                                    transaction confirmation is{' '}
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={`https://alfajores-blockscout.celo-testnet.org/tx/${transactionAddress}/token-transfers`}>
                                        <span className='font-semibold text-linkYellow'>
                                            {transactionAddress
                                                ? shrinkAnAddress(
                                                      transactionAddress,
                                                  )
                                                : 'unavailable'}
                                        </span>
                                    </a>
                                </>
                            ) : (
                                <>
                                    Your are about to stake{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    CORN and become a Masa Validator. Please
                                    confirm this transaction in your wallet
                                </>
                            )}
                        </p>
                    ) : (
                        <p className='font-light text-danger'>{error}</p>
                    )}
                </SimpleModal>
            </Modal>
            <Modal show={openWithdraw} onClose={() => setOpenWithdraw(false)}>
                <SimpleModal
                    onClose={() => {
                        setOpenWithdraw(false)
                    }}
                    title={
                        error ? (
                            'There was an error with your transaction'
                        ) : validator ? (
                            'Withdraw completed'
                        ) : depositing ? (
                            <div className='flex flex-row items-center gap-4'>
                                Waiting for confirmation
                                <Spinner color='black' />
                            </div>
                        ) : (
                            'Unstake'
                        )
                    }
                    hideFooter={depositing && !validator}
                    buttons={[
                        {
                            label: validator ? 'Dashboard' : 'Unstake',
                            onClick: validator
                                ? () => history.push(Paths.DASHBOARD_VALIDATOR)
                                : withdraw,
                        },
                    ]}>
                    {!error ? (
                        <p className='font-light text-gray8'>
                            {!depositing ? (
                                <>
                                    Your are about to unstake{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    CORN and become a Masa Validator.
                                </>
                            ) : validator ? (
                                <>
                                    You have staked{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    CORN tokens. Your transaction confirmation
                                    is{' '}
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        href={`https://alfajores-blockscout.celo-testnet.org/tx/${transactionAddress}/token-transfers`}>
                                        <span className='font-semibold text-linkYellow'>
                                            {transactionAddress
                                                ? shrinkAnAddress(
                                                      transactionAddress,
                                                  )
                                                : 'unavailable'}
                                        </span>
                                    </a>
                                </>
                            ) : (
                                <>
                                    Your are about to unstake{' '}
                                    <NumberFormat
                                        value={depositValue}
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType={'text'}
                                        className='inline'
                                    />{' '}
                                    CORN. Please confirm this transaction in
                                    your wallet
                                </>
                            )}
                        </p>
                    ) : (
                        <p className='font-light text-danger'>{error}</p>
                    )}
                </SimpleModal>
            </Modal>
        </>
    )
}
